import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";

export type PapeleraCounts = Record<string, number>;

export function usePapeleraCounts(companyId: string | null | undefined) {
  return useQuery({
    queryKey: ["papelera", "counts", companyId],
    queryFn: async () => {
      const res = await api.get("/papelera/counts");
      return (res.data?.data ?? {}) as PapeleraCounts;
    },
    staleTime: 30_000,
  });
}
